import Devise from "@kaspernj/api-maker/build/devise"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require"

const User = modelClassRequire("User")

Devise.addUserScope("user", {
  query: User.ransack().preload(["user_roles.role"])
})
